/* Components =================================================================================== */
import { Modal } from '../../../components/modal'

/* Styles ======================================================================================= */
import { Portal } from '../../../modules/components/portal'

Modal.add('Portal', Portal)
